module.exports = __webpack_public_path__ + "img/MP3.0800915f.png";